import { parse, differenceInCalendarDays } from 'date-fns';

export const mapValueToId = (data = [], mapKey) => {
  if(Array.isArray(data) && data.length){
    return data.map((value, index) => ({...value, id: value[mapKey] || index}))
  }
  return data;
}

export const getDbFormat = (date = new Date()) => {
  return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getFullYear()}` 
};

export const getBookingStatus = (booking) => {
  let status = null;
  const bookingStartDate = parse(booking?.fromDate, 'dd-MM-yyyy', new Date());
  const bookingEndDate = parse(booking?.toDate, 'dd-MM-yyyy', new Date());
  const today = new Date();
  if(booking){
    if(booking?.cancelled){
      status = "Cancelled";
    } else if(differenceInCalendarDays(bookingStartDate, today) < 0 && differenceInCalendarDays(bookingEndDate, today) < 0) {
      status = "Completed";
    } else if(differenceInCalendarDays(bookingStartDate, today) > 0 ) {
      status = "Upcoming";
    } else{
      status = "Ongoing";
      if(
        // differenceInCalendarDays(bookingStartDate, today) === 0 && 
        // differenceInCalendarDays(bookingStartDate, bookingEndDate) === 0 && 
        booking?.library?.hourlyBookingsEnabled
      ) {
        const bookingStartTime = parseFloat(booking?.fromTime);
        const bookingEndTime = parseFloat(booking?.toTime);
        const currentHour = new Date().getHours();
        if(bookingStartTime < currentHour && bookingEndTime < currentHour) {
          status = "Completed";
        } else if(bookingStartTime > currentHour) {
          status = "Upcoming";
        }
      }
    }
  }
  return status;
};

export function tConvert (time) {
  // Check correct time format and split into components
  time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice (1);  // Remove full string match value
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join (''); // return adjusted time or original string
}


